import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "@/App.css";

import { LanguageProvider } from "@/contexts/LanguageContext";
import Loader from "@/components/Loader";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import ScrollToTop from "@/components/ScrollToTop";
import { PageEnter } from "@/components/Section";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import Clients from "@/pages/Clients";
import Manpower from "@/pages/Manpower";
import Contact from "@/pages/Contact";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageEnter><Home /></PageEnter>} />
        <Route path="/about" element={<PageEnter><About /></PageEnter>} />
        <Route path="/services" element={<PageEnter><Services /></PageEnter>} />
        <Route path="/projects" element={<PageEnter><Projects /></PageEnter>} />
        <Route path="/clients" element={<PageEnter><Clients /></PageEnter>} />
        <Route path="/manpower" element={<PageEnter><Manpower /></PageEnter>} />
        <Route path="/contact" element={<PageEnter><Contact /></PageEnter>} />
        <Route path="*" element={<PageEnter><Home /></PageEnter>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-navy-800 text-white">
        <Loader />
        {/*
          NOTE: Using HashRouter for Hostinger shared-hosting friendliness.
          With HashRouter the URL becomes e.g. /#/about which works on any
          static host without server-side rewrites. The .htaccess file in
          /public is provided as a backup if you switch back to BrowserRouter.
        */}
        <HashRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <AnimatedRoutes />
          </main>
          <Footer />
          <BackToTop />
        </HashRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
